import React, { Component } from "react";
import axios from "axios";
import { baseApiUrl } from  "../axios_setup";
import { runInThisContext } from "vm";

class DominosStoreDropdown extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var custom_field = this.props.customField;
        var loading = <div>loading...</div>

        var storeSelect = <select name={custom_field.field_id}
                                  id={custom_field.field_id}
                                  className="form-control pl-0 dyn-field-border-color dyn-field-label-color"
                                  required={custom_field.required}
                                  value={custom_field.value}
                                  onFocus={this.props.onFocus}
                                  onBlur={this.props.onBlur}
                                  onChange={this.props.onChange}>

                              <option value="">Select a store...</option>

                             {this.props.stores.map(option => {
                                 return <option value={option.id} key={option.id}>{option.name}</option>
                             })}
                          </select>

        return <div>
                   <div className={custom_field.error ? "form-group invalid-field mb-5" : "form-group mb-5"} key={custom_field.id} style={{ display: custom_field.visible ? 'block' : 'none' }}>
                       <label htmlFor={custom_field.field_id} id={`${custom_field.field_id}-label`}
                              className={(custom_field.name.length > 53) ? "mb-0 wrapped-label-two-lines dyn-field-label-color" : "mb-0 wrapped-label-one-line dyn-field-label-color"}>{custom_field.required && '*'} {custom_field.name}</label>

                       <div className="select-dropdown">
                           {storeSelect}
                           <i className="fa fa-angle-down dyn-field-label-color"></i>
                       </div>

                       <span className="error-msg mb-0 dyn-field-label-color">{custom_field.error && "Please choose an option"}</span>
                   </div>
               </div>
    }
}

export default DominosStoreDropdown